import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { RemoveClassFromBody } from '../../utils/utils';
import Toolbar from '../../components/Toolbar/Toolbar';
import Sidebar from '../../components/Sidebar/Sidebar';
import Driver from '../Driver';
import Settings from '../Settings';
import CustomerAdministrator from '../Customer-administrator';
import Finance from '../Finance';
import Hr from '../Hr';
import ManagementDashboard from '../Management-dashboard/Management-dashboard';
import OperationRoom from '../Operation-room';
import UserRelationship from '../User-relationship';
import AdminUserManagementList from '../Admin-users-management';


class Layout extends Component {

    render () {
        RemoveClassFromBody();
        return (
            <div>
                <Toolbar />
                <Sidebar />
                <aside className="page-wrapper">
                    <Switch>
                        <Route path="/drivers" component={ Driver } />
                        <Route path="/settings" component={ Settings } />
                        <Route path="/customers" component={ CustomerAdministrator } />
                        <Route path="/user-relationship"  component={ UserRelationship } />
                        <Route path="/finance" component={ Finance } />
                        <Route path="/hr" component={ Hr } />
                        <Route path="/management-dashboard" component={ ManagementDashboard } />
                        <Route path="/operation-room" component={ OperationRoom } />
                        <Route path="/admin-users-management-list" component={ AdminUserManagementList } />
                        <Redirect to="/operation-room/map" />
                    </Switch>

                </aside>
            </div>
        )
    }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js